import { FilterField } from '@/components/filters/FilterBar'
import { OptionSelect } from '@/components/filters/OptionSelect'
import { BOOLEAN_OPTIONS, DistinctMultiSelect } from '@/features/report/ReportFilterBar'
import type { ReportDocument } from '@/lib/report-document'

import type { RunFilterValues } from './generate'

/** Kopya üretiminde ve "Şablondan yeniden üret"te seçilen filtre alanları (dönem hariç). */
export function RunFilterFields({
  template,
  filters,
  onChange,
}: {
  template: ReportDocument
  filters: RunFilterValues
  onChange: (next: RunFilterValues) => void
}) {
  const setFilter = (member: string, value: string[] | boolean | undefined) => {
    const { [member]: _removed, ...rest } = filters
    onChange(
      value === undefined || (Array.isArray(value) && value.length === 0)
        ? rest
        : { ...rest, [member]: value },
    )
  }

  const fields = template.filters.map((filter) => {
    const key = `${filter.view}.${filter.member}`
    const value = filters[filter.member]
    if (filter.type === 'multiSelect') {
      return (
        <DistinctMultiSelect
          key={key}
          view={filter.view}
          member={key}
          label={filter.member}
          selected={Array.isArray(value) ? value : []}
          onChange={(values) => setFilter(filter.member, values)}
        />
      )
    }
    if (filter.type === 'boolean') {
      return (
        <FilterField key={key} label={filter.member}>
          <OptionSelect
            aria-label={filter.member}
            className="w-44"
            value={typeof value === 'boolean' ? String(value) : ''}
            options={BOOLEAN_OPTIONS}
            onValueChange={(next) =>
              setFilter(filter.member, next === '' ? undefined : next === 'true')
            }
          />
        </FilterField>
      )
    }
    return null
  })
  return <>{fields}</>
}
